import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { useMemo } from "react";
import { createAgentClient } from "../api/agentClient";
import type { ClinicalRuntime } from "../auth/ClinicalRuntimeProvider";
import "./incoming-documents.css";

export function IncomingDocumentAlerts({
  runtime,
}: {
  runtime: Extract<ClinicalRuntime, { mode: "supabase" }>;
}) {
  const client = useMemo(
    () =>
      createAgentClient({
        baseUrl: runtime.config.agentApiOrigin,
        siteId: runtime.config.siteId,
        getAccessToken: runtime.workforce.accessToken,
      }),
    [runtime.config.agentApiOrigin, runtime.config.siteId, runtime.workforce.accessToken],
  );
  const alerts = useQuery({
    queryKey: ["incoming-document-alerts", runtime.config.siteId],
    queryFn: () => client.getIncomingDocumentAlerts(),
    refetchInterval: 15000,
    retry: false,
  });
  if (!alerts.data?.length) return null;
  return (
    <aside className="incoming-global-alert" role="alert" aria-label="Urgent incoming reports">
      <strong>
        {alerts.data.length} potentially urgent{" "}
        {alerts.data.length === 1 ? "report needs" : "reports need"} acknowledgement
      </strong>
      {alerts.data.slice(0, 3).map((alert) => (
        <Link key={alert.reportId} to="/attention" search={{ report: alert.reportId }}>
          {alert.title} · open source and review
        </Link>
      ))}
    </aside>
  );
}
